import { roleTypeLabel } from '../../../../components/sp-role-type/sp-role-type.exports';
import { userFromDto } from '../administrators.dto';
import { makeSelectables } from '../make-selectables';

export class Controller {

    /** @ngInject */
    constructor(
        $filter,
        $state,
        $translate,
        Alert,
        Groups,
        RoleResource,
    ) {
        this.$filter = $filter;
        this.$state = $state;
        this.$translate = $translate;
        this.Alert = Alert;
        this.Groups = Groups;
        this.RoleResource = RoleResource;
    }

    $onInit() {
        this.email = this.email || '';
        this.roleType = 'SUPER_ADMIN';
        this.userNotFound = false;
        this.applications = makeSelectables([], []);
        this.appTypes = makeSelectables([], []);
        this.groups = makeSelectables([], []);

        this.roleTypes = [
            'SUPER_ADMIN',
            'DEVELOPER_ADMIN',
            'APPLICATION_ADMIN',
            'ORGANIZATION_ADMIN',
            'READ_ONLY_ADMIN',
        ];

        this.applications$.get().then(applications => this.applications = makeSelectables([], applications));
        this.appTypes$.get().then(types => this.appTypes = makeSelectables([], types));
        this.groups$.get().then(groups => this.groups = makeSelectables([], groups));
    }

    roleTypeChanged() {
        if (this.roleType !== 'APPLICATION_ADMIN') {
            this.applications = makeSelectables([], this.applications.all());
            this.appTypes = makeSelectables([], this.appTypes.all());
        }
        if (this.roleType !== 'ORGANIZATION_ADMIN') {
            this.groups = makeSelectables([], this.groups.all());
        }
    }

    roleTypeLabel(roleType) {
        return roleTypeLabel(roleType);
    }

    getNewConfig() {
        return {
            email: this.email,
            roleType: this.roleType,
            applicationIds: this.applications.getSelectedIds(),
            applicationTypeIds: this.appTypes.getSelectedIds(),
            groupIds: this.groups.getSelectedIds(),
        };
    }

    save() {
        this.isSaving = true;
        this.RoleResource
            .addNewRole(this.companyId, this.getNewConfig())
            .then(userFromDto)
            .then((user) => {
                // replace existing user or append new one
                const i = this.administrators.findIndex(u => u.email === this.email);
                this.administrators.splice(i > -1 ? i : this.administrators.length, 1, user);
                this.Alert('success', 'company.administrators.add.added');
                this.$state.go('^');
            })
            .catch((response)=>{
            if(response.data.serviceErrorCode === "ERR_100802"){
                this.userNotFound = true;
            }
            })
            .finally(() => this.isSaving = false)
    }

    saveDisabled(form) {
        return form.$invalid || this.isSaving;
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/administrators/add/add-new-administrator.controller.js